import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRestaurant24 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2v6.78c0 .078.019.154.052.222L8 9V2h1v7l1.948.002a.5.5 0 0 0 .044-.132L11 8.78V2h1v6.78a1.5 1.5 0 0 1-.898 1.373l-.128.05L9 10.86V22H8V10.86l-1.974-.658a1.5 1.5 0 0 1-1.02-1.286L5 8.78V2h1Zm9-.066a1 1 0 0 1 .453.109l.102.06 1.332.887a2.5 2.5 0 0 1 1.107 1.902L18 5.07V13h-3v9h-1V2.934a1 1 0 0 1 1-1Zm0 1V11h2V5.07a1.5 1.5 0 0 0-.548-1.159l-.12-.089L15 2.934Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgRestaurant24;